import { Box, Button, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Colors, Email } from '@/assets';
import { Alert, Loading, PrimaryButton, showToatify } from '@/components';
import { APIresendVerifyEmail, AuthActions } from '@/features/auth';
import { useMessageData } from '@/hooks';
import { Screens } from '@/routes';

export const EmailUnverified = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isSuccess, message, setMessage, clearMessage } = useMessageData();
    const [loading, setLoading] = useState<boolean>(false);
    const onResendEmail = async () => {
        try {
            setLoading(true);
            await APIresendVerifyEmail();
            showToatify('Email resend successful!');
        } catch (error: any) {
            setMessage({ message: error.message });
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        dispatch(AuthActions.logout());
    };

    return (
        <>
            <Loading loading={loading} />
            <Email />
            <Alert isSuccess={isSuccess} message={message} clearMessage={clearMessage} />
            <Typography variant="h1" sx={{ mt: 3, fontWeight: 600, color: Colors.tangaroaBlue }}>
                Check your email
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'normal', color: Colors.lynchBlue }}>
                    We sent a verification link to
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 500, color: Colors.lynchBlue }}>
                    email
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', mt: 4, width: '100%', flexDirection: 'column', gap: 2.5 }}>
                <PrimaryButton onClick={onResendEmail} title="Resend Email Verification" />
                <Button onClick={logout} sx={{ color: Colors.lynchBlue, py: 1.5, boxShadow: 'none' }}>
                    <i className="far fa-arrow-left"></i>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: Colors.lynchBlue, ml: 0.5 }}>
                        Back to log in
                    </Typography>
                </Button>
            </Box>
        </>
    );
};
